<template>
    <div id="today" class="today-data" v-cloak v-if="item">
        <div class="day-navi">
            <div class="next"><a href="#" v-on:click.prevent="do_prev" v-if="prev">前の日</a></div>
            <div class="prev"><a href="#" v-on:click.prevent="do_next" v-if="next">次の日</a></div>
        </div>
        <transition name="fade">
            <div v-if="!loading" class="data">
                <div class="today">
                    <span class="year">{{ item.current.year }}</span>
                    <span class="date">{{ item.current.date }}</span>
                    <span class="weekday">{{ item.current.weekday }}</span>
                </div>
                <div class="item">
                    <div class="ichiba">
                        <div class="area">市場棟</div>
                        <div class="time" v-if="item.ichiba.holiday === false">{{ item.ichiba.hour.open }}〜{{ item.ichiba.hour.close }}<span class="memo">{{ item.ichiba.hour.memo }}</span></div>
                        <div class="time" v-else>休業日</div>
                    </div>
                    <div class="aji">
                        <div class="area">味横丁</div>
                        <div class="time" v-if="item.aji.holiday === false">{{ item.aji.hour.open }}〜{{ item.aji.hour.close }}<span class="memo">{{ item.aji.hour.memo }}</span></div>
                        <div class="time" v-else>休業日</div>
                    </div>
                    <div class="kuriya">
                        <div class="area">厨スタジアム</div>
                        <div class="time" v-if="item.kuriya.holiday === false">{{ item.kuriya.hour.open }}〜{{ item.kuriya.hour.close }}<span class="memo">{{ item.kuriya.hour.memo }}</span></div>
                        <div class="time" v-else>休業日</div>
                    </div>
                    <div class="land">
                        <div class="area">くりやランド</div>
                        <div class="time" v-if="item.land.holiday === false">{{ item.land.hour.open }}〜{{ item.land.hour.close }}<span class="memo">{{ item.land.hour.memo }}</span></div>
                        <div class="time" v-else>休業日</div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="calendar_link"><i class="fas fa-calendar-alt icon"></i><a href="javascript:return false;" data-toggle>カレンダーで日付指定する</a><br><flat-pickr v-model="current_date" :config="flatpickr" class="hidden" @on-close="cal_close"></flat-pickr></div>
    </div>
</template>

<script>
import axios from 'axios';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/confetti.css';
import { Japanese } from "flatpickr/dist/l10n/ja.js"
const endpoint = '/calendar/api';

export default {
    name: 'today',
    data () {
        return {
            item: null,
            current: endpoint,
            next: null,
            prev: null,
            current_date: null,
            weekday: [
                '日', '月', '火', '水', '木', '金', '土',
            ],
            loading: false,
            flatpickr: {
                locale: Japanese,
                minDate: '2018-03-01',
                dateFormat: 'Y-m-d',
                wrap: true,
                disableMobile: true,
            },
        };
    },
    components: {
        flatPickr
    },
    created: function () {
        this.load();
    },
    watch: {
        current: function () {
            this.load();
        },
        current_date: function () {
            this.set_current(this.current_date);
        },
    },
    methods: {
        set_current: function (date) {
            this.current = endpoint + '/' + date;
        },
        load: function () {
            var self = this;
            self.loading = true;
            axios.get(self.current)
            .then(function (response) {
                var data = response.data;
                if (!data.item || typeof data.item !== 'object') {
                    return;
                }
                var date = new Date(data.item.date);
                
                self.item = {
                    ichiba: data.item.ichiba,
                    aji: data.item.aji,
                    kuriya: data.item.kuriya,
                    land: data.item.land,
                    current: {
                        year: date.getFullYear(),
                        date: (date.getMonth() + 1) + '/' + date.getDate(),
                        weekday: self.weekday[date.getDay()],
                    }
                };
                self.next = data.next;
                self.prev = data.prev;
            }).catch(function (error) {
                
            }).then(function () {
                self.loading = false;
            });
        },
        do_next: function () {
            this.current = this.next;
        },
        do_prev: function () {
            this.current = this.prev;
        },
        cal_close: function (selectedDates, dateStr, instance) {
            instance.input.blur();
        },
    },
};
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
.hidden {
    margin: 0;
    padding: 0;
    width: 12em;
    height: 1px;
    display: inline-block;
    border: 0;
    opacity: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.flatpickr-months,
.flatpickr-month,
.flatpickr-weekdays,
span.flatpickr-weekday {
    background: #e60012;
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
    background: #e60012;
    border-color: #e60012;
}
.flatpickr-calendar.arrowTop:after {
    border-bottom-color: #e60012;
}
</style>



// WEBPACK FOOTER //
// src/Today.vue